<template>
  <div id="frequencia-container" v-if="!carregando">
    <Breadcrumb :items="breadcrumbItems" />
    <div class="infos-encontro-container">
      <h4>FREQUÊNCIA {{ dadosEncontros?.titulo.toUpperCase() }}</h4>
      <div class="infos-encontro">
        <p>Modalidade de Execução: {{ dadosAtividade?.modalidade }}</p>
        <p>
          Data da Realização: {{ formatarData(dadosEncontros?.inicio_periodo) }}
        </p>
        <p>
          Horáriro da Realização:
          {{ formatarDataHora(dadosEncontros?.inicio_periodo).split(" ")[1] }}
        </p>
      </div>
    </div>
    <div class="opcoes-selecao">
      <!-- Summary -->
      <div class="summary">
        <div class="summary-item">
          <span class="dot presente"></span>
          Presentes: <strong>{{ presenteCount }}</strong>
        </div>
        <div class="summary-item">
          <span class="dot falta"></span>
          Faltas: <strong>{{ faltaCount }}</strong>
        </div>
        <div class="summary-item">
          <span class="dot pendente"></span>
          Pendentes: <strong>{{ pendenteCount }}</strong>
        </div>
      </div>
      <div class="options" v-if="podeEditarFrequencia && participantes.length > 0">
        <div>
          <input id="todos-presentes" type="radio" name="estado-todos" v-model="statusTodos" value="presente" />
          <label for="todos-presentes">Todos presentes</label>
        </div>

        <div>
          <input id="todos-faltaram" type="radio" name="estado-todos" v-model="statusTodos" value="falta" />
          <label for="todos-faltaram">Todos faltaram</label>
        </div>
      </div>
      <div v-else-if="isAtividadeEncerrada" class="status-message">
        <p>
          ✓ Atividade encerrada. Frequência disponível apenas para visualização.
        </p>
      </div>
    </div>
    <div class="wrapper">
      <!-- Mini formulário para CPF ou E-mail (Apenas para modalidade sem inscrição mas com frequência) -->
      <div v-if="
        dadosAtividade?.modalidadeInscricao ===
        'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA' &&
        podeEditarFrequencia
      " class="mini-form-container">
        <h5>Adicionar Participante</h5>
        <div class="busca-tipo-selector">
          <label class="radio-selector">
            <input type="radio" v-model="tipoPesquisa" value="cpf" />
            <span>CPF</span>
          </label>
          <label class="radio-selector">
            <input type="radio" v-model="tipoPesquisa" value="email" />
            <span>E-mail</span>
          </label>
        </div>
        <div class="search-box">
          <input v-if="tipoPesquisa === 'cpf'" type="text" class="input-search" placeholder="000.000.000-00"
            v-model="cpfPesquisa" v-maska="'###.###.###-##'" @keyup.enter="buscarParticipante" />
          <input v-else type="email" class="input-search" placeholder="email@exemplo.com" v-model="emailPesquisa"
            @keyup.enter="buscarParticipante" />
          <button class="btn-buscar" @click.prevent="buscarParticipante" :disabled="buscando">
            {{ buscando ? "Buscando..." : "Buscar" }}
          </button>
        </div>

        <!-- Retângulo do participante encontrado ou não cadastrado -->
        <div v-if="usuarioEncontrado" class="participante-resultado-card animate-fade-in"
          :class="{ 'card-externo': !usuarioEncontrado.jaExisteBD }">
          <div class="info">
            <div class="card-header-badge">
              <span class="label">Participante:</span>
              <span class="badge-participante"
                :class="usuarioEncontrado.jaExisteBD ? 'badge-cadastrado' : 'badge-externo'">
                {{ usuarioEncontrado.jaExisteBD ? "Cadastrado no Sistema" : "Participante Externo" }}
              </span>
            </div>
            <strong class="nome">{{ usuarioEncontrado.nome }}</strong>
            <span v-if="usuarioEncontrado.cpf" class="identificador-detalhe">
              CPF: {{ formatarCPFMascarado(usuarioEncontrado.cpf) }}
            </span>
            <span v-else-if="usuarioEncontrado.email" class="identificador-detalhe">
              E-mail: {{ usuarioEncontrado.email }}
            </span>
            <span v-if="!usuarioEncontrado.jaExisteBD" class="texto-ajuda-externo">
              A frequência deste participante será vinculada automaticamente quando ele criar uma conta no GEX.
            </span>
          </div>
          <button class="btn-adicionar-lista" :class="{ 'btn-adicionar-externo': !usuarioEncontrado.jaExisteBD }"
            @click.prevent="adicionarUsuarioEncontrado">
            {{ usuarioEncontrado.jaExisteBD ? "+ Adicionar à Lista" : "+ Adicionar como Externo" }}
          </button>
        </div>
      </div>

      <div class="table-container" v-if="participantes.length > 0">
        <table class="attendance-table">
          <thead>
            <tr>
              <th class="col-name">Nome do participante</th>
              <th v-if="
                dadosAtividade?.modalidadeInscricao !==
                'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
              " class="col-email">
                E-mail
              </th>
              <th v-else class="col-cpf">
                CPF / E-mail
              </th>
              <th class="col-status">Presente</th>
              <th class="col-status">Falta</th>
              <th class="col-status">Pendente</th>
              <th v-if="
                dadosAtividade?.modalidadeInscricao ===
                'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
              " class="col-acoes">
                Remover
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(participante, index) in participantes" :key="participante.participanteId ||
              participante.id ||
              participante.cpf ||
              participante.email ||
              index
              " :class="{
                'row-even': index % 2 === 0,
                'row-odd': index % 2 !== 0,
              }">
              <td class="col-name">
                <div class="nome-participante-wrapper">
                  <span v-if="participante.nome === 'NÃO CADASTRADO'" class="badge-externo-tabela">
                    EXTERNO
                  </span>
                  <span v-if="participante.nome">{{ participante.nome }}</span>
                  <span v-else class="placeholder">Nome do participante</span>
                </div>
              </td>
              <td v-if="
                dadosAtividade?.modalidadeInscricao !==
                'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
              " class="col-email">
                <span v-if="participante.email">{{ participante.email }}</span>
                <span v-else class="placeholder">usuario@email.com</span>
              </td>
              <td v-else class="col-cpf">
                <span v-if="participante.cpf">{{
                  formatarCPFMascarado(participante.cpf)
                }}</span>
                <span v-else-if="participante.email">{{
                  participante.email
                }}</span>
                <span v-else>-</span>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    value="presente" v-model="participante.status" :disabled="!podeEditarFrequencia" />
                  <span class="custom-radio" :class="{ selected: participante.status === 'presente' }"></span>
                </label>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    value="falta" v-model="participante.status" :disabled="!podeEditarFrequencia" />
                  <span class="custom-radio" :class="{
                    selected: participante.status === 'falta',
                    falta: participante.status === 'falta',
                  }"></span>
                </label>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    :value="null" v-model="participante.status" :disabled="!podeEditarFrequencia" />
                  <span class="custom-radio" :class="{
                    selected: participante.status === null,
                    pendente: participante.status === null,
                  }"></span>
                </label>
              </td>
              <td v-if="
                dadosAtividade?.modalidadeInscricao ===
                'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
              " class="col-status center">
                <button class="btn-remover" @click.prevent="removerParticipanteLista(index)"
                  :disabled="!podeEditarFrequencia">
                  <span class="trash-icon">🗑️</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-container-empty" v-else>
        <p v-if="isCriterioCoordenacao">
          Nenhum participante com inscrição confirmada pela coordenação nesta atividade.
        </p>
        <p v-else-if="
          dadosAtividade?.modalidadeInscricao ===
          'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
        ">
          Nenhum participante adicionado para frequência neste encontro.
        </p>
        <p v-else>
          Nenhum participante inscrito nesta atividade.
        </p>
      </div>
    </div>
    <div class="botoes-container">
      <button v-if="podeSalvarFrequencia" class="btn-salvar" @click="salvarFrequencia" :disabled="salvando">
        {{ salvando ? "Salvando..." : "Salvar Frequência" }}
      </button>
      <button class="btn-voltar" @click="voltarAtividade">
        Voltar
      </button>
    </div>
  </div>
  <Carregamento v-else :mensagemCarregamento="'Carregando Frequência'" />
</template>
<script setup>
import router from "@/router";
import atividadeService from "@/service/atividadeService";
import encontrosService from "@/service/encontrosService";
import participantesAtividadeService from "@/service/participantesAtividadeService";
import frequenciaService from "@/service/frequenciaService";
import usuariosService from "@/service/usuariosService";
import {
  formatarData,
  formatarDataHora,
  getLocalDateTime,
  formatarCPFMascarado,
} from "@/utils/FormatarEntradas";
import { onMounted, ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { vMaska } from "maska/vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import { useToast } from "@/composables/useToast";

const route = useRoute();
const toast = useToast();

const dadosAtividade = ref(null);
const dadosEncontros = ref(null);
const carregando = ref(true);
const salvando = ref(false);
const statusTodos = ref(null);
const participantes = ref([]);
const frequenciasExistentes = ref([]);

// Estados da busca de participantes (modalidade sem inscrição com frequência).
const tipoPesquisa = ref("cpf");
const cpfPesquisa = ref("");
const emailPesquisa = ref("");
const buscando = ref(false);
const usuarioEncontrado = ref(null);

const modalidadeSemInscricaoComFrequencia = computed(
  () =>
    dadosAtividade.value?.modalidadeInscricao ===
    "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA"
);

const isAtividadeEncerrada = computed(() => {
  const status = dadosAtividade.value?.status;
  return ["ENCERRADA", "CANCELADA", "FINALIZADO", "CONCLUIDA"].includes(
    status
  );
});

const podeEditarFrequencia = computed(() => {
  if (isAtividadeEncerrada.value) return false;

  const statusEncontro = dadosEncontros.value?.status;
  return ["EM_EXECUCAO", "FINALIZADO"].includes(statusEncontro);
});

const isCriterioCoordenacao = computed(() => {
  const criterio =
    dadosAtividade.value?.criterioInscricao ||
    dadosAtividade.value?.criterioDeAvaliacaoDeInscricao ||
    "";

  return [
    "CRITERIODACOORDENACAO",
    "CRITERIO_DA_COORDENACAO",
    "Critério da Coordenação",
  ].includes(criterio);
});

const podeSalvarFrequencia = computed(() => {
  if (!podeEditarFrequencia.value || salvando.value) return false;
  if (participantes.value.length > 0) return true;

  return (
    modalidadeSemInscricaoComFrequencia.value &&
    frequenciasExistentes.value.some(
      (frequencia) => frequencia.statusFrequencia !== "NAO_LANCADA"
    )
  );
});

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;
  const atividadeId = route.params.atividadeId;

  return [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
    { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
    { label: "Atividades", to: `/acao/${acaoId}/atividades-acao` },
    {
      label: dadosAtividade.value?.nome || "Atividade",
      to: `/acao/${acaoId}/atividades/${atividadeId}`,
    },
    {
      label: "Realizar Frequência",
      to: `/acao/${acaoId}/atividades/${atividadeId}/cadastro-frequencia/${route.params.encontroId}`,
    },
  ];
});

/**
 * Executa tarefas independentes em paralelo, limitando a quantidade de
 * requisições simultâneas para não sobrecarregar a API.
 */
async function executarComConcorrencia(itens, limite, callback) {
  const resultados = new Array(itens.length);
  let indice = 0;

  async function worker() {
    while (true) {
      const indiceAtual = indice++;
      if (indiceAtual >= itens.length) return;

      try {
        resultados[indiceAtual] = {
          sucesso: true,
          resultado: await callback(itens[indiceAtual]),
          item: itens[indiceAtual],
        };
      } catch (erro) {
        resultados[indiceAtual] = {
          sucesso: false,
          erro,
          item: itens[indiceAtual],
        };
      }
    }
  }

  const quantidadeWorkers = Math.min(Math.max(limite, 1), itens.length);
  await Promise.all(
    Array.from({ length: quantidadeWorkers }, () => worker())
  );

  return resultados;
}

function isStatusInscricaoConfirmada(status) {
  return String(status || "").toUpperCase() === "CONFIRMADA";
}

/**
 * Carrega atividade e encontro simultaneamente. Depois que a modalidade da
 * atividade é conhecida, carrega participantes e frequências em paralelo.
 */
async function carregarDadosIniciais() {
  carregando.value = true;

  try {
    const [atividade, encontros] = await Promise.all([
      atividadeService.getAtividadeId(route.params.atividadeId),
      encontrosService.getEncontros(0, 100, route.params.atividadeId),
    ]);

    dadosAtividade.value = atividade;

    dadosEncontros.value = Array.isArray(encontros)
      ? encontros.find(
        (encontro) => encontro.encontroId === route.params.encontroId
      ) || null
      : null;

    if (!dadosEncontros.value) {
      throw new Error("Encontro não encontrado.");
    }

    const [listaParticipantes, frequencias] = await Promise.all([
      carregarParticipantes(),
      frequenciaService.getFrequencia(route.params.encontroId),
    ]);

    participantes.value = listaParticipantes;
    frequenciasExistentes.value = Array.isArray(frequencias)
      ? frequencias
      : [];

    aplicarFrequenciasExistentes();
  } catch (error) {
    console.error("Erro ao carregar dados da frequência:", error);
    toast.erro(
      error?.message === "Encontro não encontrado."
        ? error.message
        : "Não foi possível carregar os dados da frequência. Tente novamente."
    );
  } finally {
    carregando.value = false;
  }
}

async function carregarParticipantes() {
  // Nesta modalidade, os participantes são adicionados manualmente na tela.
  if (modalidadeSemInscricaoComFrequencia.value) return [];

  let lista = await participantesAtividadeService.getParticipantesAtividade(
    0,
    1000,
    route.params.atividadeId,
    isCriterioCoordenacao.value
  );

  lista = Array.isArray(lista) ? lista : [];

  if (isCriterioCoordenacao.value && lista.length > 0) {
    const todosPossuemStatus = lista.every(
      (participante) =>
        participante.statusInscricao !== undefined &&
        participante.statusInscricao !== null
    );

    if (todosPossuemStatus) {
      lista = lista.filter((participante) =>
        isStatusInscricaoConfirmada(participante.statusInscricao)
      );
    } else {
      // Fallback: só consulta a lista de inscritos se a primeira resposta
      // não trouxer status de inscrição para todos os participantes.
      try {
        const inscritos =
          await participantesAtividadeService.getInscritosByAtividade(
            route.params.atividadeId
          );

        if (Array.isArray(inscritos)) {
          const confirmadosIds = new Set();
          const confirmadosEmails = new Set();

          inscritos.forEach((inscrito) => {
            if (!isStatusInscricaoConfirmada(inscrito.statusInscricao)) return;

            const id = inscrito.id || inscrito.participanteId;
            if (id) confirmadosIds.add(id);

            if (inscrito.email) {
              confirmadosEmails.add(inscrito.email.trim().toLowerCase());
            }
          });

          lista = lista.filter((participante) => {
            const id = participante.participanteId || participante.id;
            const email = participante.email?.trim().toLowerCase();

            return (
              (id && confirmadosIds.has(id)) ||
              (email && confirmadosEmails.has(email))
            );
          });
        }
      } catch (error) {
        // Mantém o comportamento anterior: a falha do fallback não impede
        // a exibição da lista principal já recebida.
        console.warn("Erro ao validar inscrições dos participantes:", error);
      }
    }
  }

  return lista.map((participante) => ({
    ...participante,
    status: null,
  }));
}

function mapearStatusFrequencia(status) {
  if (status === "PRESENCA") return "presente";
  if (status === "FALTA") return "falta";
  return null;
}

function aplicarFrequenciasExistentes() {
  const frequencias = frequenciasExistentes.value;
  if (!frequencias.length) return;

  if (modalidadeSemInscricaoComFrequencia.value) {
    participantes.value = frequencias
      .filter((frequencia) => frequencia.statusFrequencia !== "NAO_LANCADA")
      .map((frequencia) => ({
        id: frequencia.participanteId,
        participanteId: frequencia.participanteId,
        nome: frequencia.nomeParticipante,
        cpf: frequencia.cpf,
        email: frequencia.email,
        status: mapearStatusFrequencia(frequencia.statusFrequencia),
      }));

    return;
  }

  // O Map evita procurar a frequência percorrendo o array inteiro para
  // cada participante (menos processamento em listas maiores).
  const frequenciasPorParticipante = new Map(
    frequencias
      .filter((frequencia) => frequencia.participanteId)
      .map((frequencia) => [
        frequencia.participanteId,
        frequencia,
      ])
  );

  participantes.value = participantes.value.map((participante) => {
    const id = participante.participanteId || participante.id;
    const frequencia = frequenciasPorParticipante.get(id);

    return {
      ...participante,
      status: mapearStatusFrequencia(frequencia?.statusFrequencia),
    };
  });
}

function normalizarCpf(cpf) {
  return String(cpf || "").replace(/\D/g, "");
}

async function buscarParticipante() {
  const cpf = tipoPesquisa.value === "cpf" ? cpfPesquisa.value : "";
  const email = tipoPesquisa.value === "email" ? emailPesquisa.value.trim() : "";
  const cpfLimpo = normalizarCpf(cpf);
  const emailNormalizado = email.toLowerCase();

  if (tipoPesquisa.value === "cpf") {
    if (cpfLimpo.length !== 11) {
      toast.aviso("Por favor, digite um CPF válido com 11 dígitos.");
      return;
    }

    const jaExiste = participantes.value.some(
      (participante) => normalizarCpf(participante.cpf) === cpfLimpo
    );

    if (jaExiste) {
      toast.aviso("Este CPF já está adicionado na lista deste encontro.");
      return;
    }
  } else {
    if (!emailNormalizado || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailNormalizado)) {
      toast.aviso("Por favor, digite um e-mail válido.");
      return;
    }

    const jaExiste = participantes.value.some(
      (participante) =>
        participante.email?.trim().toLowerCase() === emailNormalizado
    );

    if (jaExiste) {
      toast.aviso("Este e-mail já está adicionado na lista deste encontro.");
      return;
    }
  }

  if (buscando.value) return;

  buscando.value = true;
  usuarioEncontrado.value = null;

  try {
    const usuario = await usuariosService.getUsuarioPorCpfOuEmail(
      tipoPesquisa.value === "cpf" ? cpf : "",
      tipoPesquisa.value === "email" ? email : "",
      route.params.atividadeId
    );

    if (usuario?.id) {
      usuarioEncontrado.value = {
        id: usuario.id,
        nome: usuario.nome,
        cpf: usuario.cpf,
        email: usuario.email,
        jaExisteBD: true,
      };

      toast.sucesso(`Participante "${usuario.nome}" encontrado no sistema!`);
      return;
    }

    usuarioEncontrado.value = {
      nome: "NÃO CADASTRADO",
      cpf: tipoPesquisa.value === "cpf" ? cpfLimpo : null,
      email: tipoPesquisa.value === "email" ? email : null,
      jaExisteBD: false,
    };

    toast.info(
      "Participante não encontrado. Você pode adicioná-lo como participante externo."
    );
  } catch (error) {
    console.error("Erro ao buscar participante:", error);
    toast.erro(
      "Não foi possível consultar o participante. Verifique sua conexão e tente novamente."
    );
  } finally {
    buscando.value = false;
  }
}

function adicionarUsuarioEncontrado() {
  if (!usuarioEncontrado.value) return;

  const usuario = usuarioEncontrado.value;

  participantes.value.push({
    id: usuario.id || null,
    nome: usuario.nome,
    cpf: usuario.cpf || null,
    email: usuario.email || null,
    status: "presente",
  });

  toast.sucesso(
    usuario.jaExisteBD
      ? "Participante adicionado à lista com presença marcada!"
      : "Participante externo adicionado à lista com presença marcada!"
  );

  usuarioEncontrado.value = null;
  cpfPesquisa.value = "";
  emailPesquisa.value = "";
}

function removerParticipanteLista(index) {
  participantes.value.splice(index, 1);
}

const resumoFrequencia = computed(() =>
  participantes.value.reduce(
    (resumo, participante) => {
      if (participante.status === "presente") {
        resumo.presentes++;
      } else if (participante.status === "falta") {
        resumo.faltas++;
      } else {
        resumo.pendentes++;
      }

      return resumo;
    },
    { presentes: 0, faltas: 0, pendentes: 0 }
  )
);

const presenteCount = computed(() => resumoFrequencia.value.presentes);
const faltaCount = computed(() => resumoFrequencia.value.faltas);
const pendenteCount = computed(() => resumoFrequencia.value.pendentes);

watch(statusTodos, (novoStatus) => {
  if (!novoStatus || !podeEditarFrequencia.value) return;

  participantes.value.forEach((participante) => {
    participante.status = novoStatus;
  });
});

async function salvarFrequencia() {
  if (salvando.value) return;

  const pendentes = participantes.value.filter(
    (participante) => participante.status === null
  );

  if (pendentes.length > 0) {
    toast.aviso(
      `Defina o status de presença/falta para todos os ${pendentes.length} participante(s) pendente(s) antes de salvar.`
    );
    return;
  }

  salvando.value = true;

  try {
    const modalidade = dadosAtividade.value?.modalidadeInscricao;
    const encontroId = route.params.encontroId;
    const dataHoraRegistro = getLocalDateTime(new Date(), "BR");
    const semInscricao = [
      "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA",
      "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA",
    ].includes(modalidade);

    const erros = [];
    let frequenciasEnviadas = 0;

    if (semInscricao) {
      const idsAtuais = new Set(
        participantes.value
          .map((participante) => participante.participanteId || participante.id)
          .filter(Boolean)
      );

      const removidos = frequenciasExistentes.value.filter(
        (frequencia) =>
          frequencia.statusFrequencia !== "NAO_LANCADA" &&
          frequencia.participanteId &&
          !idsAtuais.has(frequencia.participanteId)
      );

      const resultadosRemocao = await executarComConcorrencia(
        removidos,
        5,
        (frequencia) =>
          frequenciaService.deleteFrequencia(encontroId, {
            participanteId: frequencia.participanteId,
            dataHoraRegistro,
            statusFrequencia: "FALTA",
          })
      );

      resultadosRemocao
        .filter((resultado) => !resultado.sucesso)
        .forEach((resultado) => {
          console.warn("Erro ao remover frequência:", resultado.erro);
          erros.push(
            `Erro ao remover frequência do participante ${resultado.item.nomeParticipante || resultado.item.participanteId}`
          );
        });
    }

    const participantesParaSalvar = participantes.value.filter(
      (participante) => participante.status !== null
    );

    const participantesValidos = participantesParaSalvar.filter((participante) => {
      if (semInscricao) {
        const temIdentificador =
          participante.cpf ||
          participante.email ||
          participante.matricula ||
          participante.siap;

        if (!temIdentificador) {
          erros.push(
            `Participante ${participante.nome || "sem nome"} sem CPF, e-mail, matrícula ou SIAP não pode ser registrado.`
          );
          return false;
        }

        return true;
      }

      if (!participante.participanteId) {
        erros.push(
          `Participante ${participante.nome || "sem nome"} não possui identificador de inscrição.`
        );
        return false;
      }

      return true;
    });

    const resultados = await executarComConcorrencia(
      participantesValidos,
      5,
      (participante) => {
        const statusFrequencia =
          participante.status === "presente" ? "PRESENCA" : "FALTA";

        const payload = semInscricao
          ? {
            frequenciaSemInscricao: {
              cpf: participante.cpf || null,
              email: participante.email || null,
              matricula: participante.matricula || null,
              siap: participante.siap || null,
              dataHoraRegistro,
              statusFrequencia,
            },
          }
          : {
            frequenciaComInscricao: {
              participanteId: participante.participanteId,
              dataHoraRegistro,
              statusFrequencia,
            },
          };

        return frequenciaService.postFrequencia(payload, encontroId);
      }
    );

    frequenciasEnviadas = resultados.filter((resultado) => resultado.sucesso).length;

    resultados
      .filter((resultado) => !resultado.sucesso)
      .forEach((resultado) => {
        console.warn(
          `Erro ao registrar frequência de ${resultado.item.nome || resultado.item.email || "participante"}:`,
          resultado.erro
        );
        erros.push(
          `Erro ao registrar ${resultado.item.nome || resultado.item.email || "participante"}`
        );
      });

    if (erros.length === 0) {
      toast.sucesso(
        `Frequência salva com sucesso! ${frequenciasEnviadas} participante(s) registrado(s).`,
        { persist: true }
      );
      voltarAtividade();
      return;
    }

    toast.aviso(
      `Frequência salva para ${frequenciasEnviadas} participante(s). Verifique: ${erros.join("; ")}`
    );
  } catch (error) {
    console.error("Erro ao salvar frequência:", error);
    toast.erro(
      "Erro ao salvar frequência: " + (error?.message || "Tente novamente.")
    );
  } finally {
    salvando.value = false;
  }
}

function voltarAtividade() {
  router.back();
}

onMounted(carregarDadosIniciais);
</script>


<style scoped>
.infos-encontro {
  margin: 10px 0 0 15px;
}

.infos-encontro p {
  margin: 0;
  padding: 0;
}

.opcoes-selecao {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2rem 3rem 10px 3rem;
}

.options {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
}

.wrapper {
  font-family: "DM Sans", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.table-container {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 16px hsla(258, 53%, 28%, 0.6);
}

.table-container-empty {
  background: var(--branco);
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.table-container-empty p {
  margin: 0;
  font-size: 16px;
  color: var(--roxo-primario);
  font-weight: 500;
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--branco);
}

/* HEADER */
thead tr {
  background: var(--roxo-primario);
}

thead th {
  color: var(--branco);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding: 13px 18px;
  text-align: left;
}

thead th.col-status {
  text-align: center;
}

/* COLUMNS */
.col-name {
  width: 30%;
}

.col-email {
  width: 35%;
}

.col-status {
  width: 11.67%;
}

/* ROWS */
tbody tr {
  transition: background 0.15s;
  border-bottom: 1px solid var(--roxo-superficie);
}

tbody tr:last-child {
  border-bottom: none;
}

.row-even {
  background: var(--branco);
}

.row-odd {
  background: var(--roxo-superficie);
}

tbody tr:hover {
  background: var(--roxo-superficie);
}

tbody td {
  padding: 11px 18px;
  font-size: 0.875rem;
  color: var(--roxo-escuro);
}

tbody td.center {
  text-align: center;
}

.placeholder {
  color: var(--roxo-claro);
}

/* RADIO */
.radio-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.radio-label input[type="radio"] {
  display: none;
}

.custom-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--roxo-claro);
  background: var(--branco);
  display: inline-block;
  transition:
    border-color 0.18s,
    background 0.18s,
    box-shadow 0.18s;
  position: relative;
}

.custom-radio.selected {
  border-color: var(--roxo-medio);
  background: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.18);
}

.custom-radio.selected::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--branco);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-radio.falta {
  border-color: var(--vermelho);
  background: var(--vermelho);
  box-shadow: 0 0 0 3px hsla(0, 72%, 51%, 0.15);
}

.custom-radio.pendente {
  border-color: var(--roxo-claro);
  background: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.15);
}

.custom-radio.pendente::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--branco);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* SUMMARY */
.summary {
  display: flex;
  gap: 1.5rem;
  font-size: 0.875rem;
  color: var(--roxo-primario);
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-item strong {
  color: var(--roxo-escuro);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot.presente {
  background: var(--roxo-medio);
}

.dot.falta {
  background: var(--vermelho);
}

.dot.pendente {
  background: var(--roxo-claro);
}

/* BOTÕES */
.botoes-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 2rem;
}

.btn-salvar {
  padding: 12px 32px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-salvar:hover {
  background-color: var(--roxo-medio);
}

.btn-voltar {
  padding: 12px 32px;
  background-color: var(--branco);
  color: var(--roxo-medio);
  border: 2px solid var(--roxo-medio);
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-voltar:hover {
  background-color: var(--roxo-superficie);
}

/* Mini formulário */
.mini-form-container {
  background: var(--branco);
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px hsla(258, 53%, 28%, 0.08);
  border: 1px solid var(--roxo-superficie);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.mini-form-container h5 {
  margin: 0;
  color: var(--roxo-primario);
  font-size: 1.1rem;
  font-weight: 600;
}

.busca-tipo-selector {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.25rem;
}

.radio-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--roxo-primario);
  cursor: pointer;
  user-select: none;
}

.radio-selector input[type="radio"] {
  accent-color: var(--roxo-medio);
  width: 16px;
  height: 16px;
}

.search-box {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.input-search {
  flex: 1;
  padding: 10px 14px;
  border: 2px solid var(--roxo-claro);
  border-radius: 8px;
  font-size: 0.95rem;
  color: var(--roxo-escuro);
  background-color: var(--roxo-superficie);
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.input-search:focus {
  outline: none;
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.15);
  background-color: var(--branco);
}

.btn-buscar {
  padding: 10px 24px;
  background-color: var(--roxo-medio);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.2s;
  min-width: 110px;
}

.btn-buscar:hover:not(:disabled) {
  background-color: var(--roxo-primario);
}

.btn-buscar:disabled {
  background-color: var(--roxo-claro);
  cursor: not-allowed;
}

/* Card de Resultado da busca */
.participante-resultado-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--branco);
  border: 1px solid var(--roxo-claro);
  padding: 1rem 1.25rem;
  border-radius: 10px;
  margin-top: 0.5rem;
  gap: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.participante-resultado-card.card-externo {
  background: hsla(258, 60%, 98%, 1);
  border: 1px dashed var(--roxo-medio);
}

.participante-resultado-card .info {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.9rem;
  color: var(--roxo-escuro);
}

.card-header-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.participante-resultado-card .label {
  color: var(--roxo-medio);
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.badge-participante {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
}

.badge-participante.badge-cadastrado {
  background-color: hsla(145, 63%, 92%, 1);
  color: hsla(145, 63%, 30%, 1);
}

.badge-participante.badge-externo {
  background-color: hsla(258, 53%, 92%, 1);
  color: var(--roxo-primario);
  border: 1px solid hsla(258, 53%, 80%, 1);
}

.participante-resultado-card .nome {
  font-size: 1.05rem;
  color: var(--roxo-escuro);
}

.participante-resultado-card .identificador-detalhe {
  color: var(--roxo-medio);
  font-family: monospace;
  font-size: 0.85rem;
}

.texto-ajuda-externo {
  color: var(--roxo-primario);
  font-size: 0.75rem;
  opacity: 0.85;
}

.btn-adicionar-lista {
  padding: 10px 18px;
  background-color: var(--verde);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.btn-adicionar-lista:hover {
  filter: brightness(0.92);
  transform: translateY(-1px);
}

.btn-adicionar-lista.btn-adicionar-externo {
  background-color: var(--roxo-primario);
}

.btn-adicionar-lista.btn-adicionar-externo:hover {
  background-color: var(--roxo-escuro);
}

/* Badge na tabela de participantes */
.nome-participante-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.badge-externo-tabela {
  background-color: hsla(258, 53%, 92%, 1);
  color: var(--roxo-primario);
  border: 1px solid hsla(258, 53%, 80%, 1);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 4px;
  letter-spacing: 0.04em;
}

/* Animação */
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ações / Remoção na Tabela */
.btn-remover {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-remover:hover:not(:disabled) {
  background-color: hsla(0, 72%, 51%, 0.1);
}

.btn-remover:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.trash-icon {
  font-size: 1.1rem;
}

/* placeholders na tabela */
.placeholder {
  color: var(--roxo-claro);
  font-style: italic;
}

/* Layout responsivo */
#frequencia-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

#frequencia-container *,
#frequencia-container *::before,
#frequencia-container *::after {
  box-sizing: border-box;
}

.infos-encontro-container {
  width: 100%;
  min-width: 0;
  padding: 0 1rem;
}

.infos-encontro-container h4 {
  overflow-wrap: anywhere;
}

.opcoes-selecao {
  align-items: center;
  gap: 1rem 1.5rem;
  min-width: 0;
}

.summary,
.options {
  min-width: 0;
}

.options {
  flex-wrap: wrap;
  align-items: center;
}

.table-container {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.attendance-table {
  min-width: 720px;
}

.attendance-table th,
.attendance-table td {
  overflow-wrap: anywhere;
}

.wrapper {
  width: 100%;
  min-width: 0;
  padding: 0 1rem;
}

.mini-form-container,
.participante-resultado-card,
.table-container-empty {
  min-width: 0;
  max-width: 100%;
}

.input-search {
  min-width: 0;
}

.botoes-container {
  flex-wrap: wrap;
}

.btn-salvar,
.btn-voltar {
  min-height: 44px;
}

@media (max-width: 900px) {
  .opcoes-selecao {
    padding: 1.5rem 1rem 0.75rem;
  }

  .summary {
    flex-wrap: wrap;
    gap: 0.75rem 1rem;
  }

  .attendance-table th,
  .attendance-table td {
    padding: 10px 12px;
  }

  .mini-form-container {
    padding: 1.25rem;
  }
}

@media (max-width: 600px) {
  .infos-encontro-container {
    padding: 0 0.75rem;
  }

  .infos-encontro-container h4 {
    font-size: 1rem;
    line-height: 1.4;
  }

  .infos-encontro {
    margin: 0.75rem 0 0;
    display: grid;
    gap: 0.35rem;
  }

  .infos-encontro p {
    font-size: 0.85rem;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .opcoes-selecao {
    padding: 1rem 0.75rem 0.75rem;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    font-size: 0.8rem;
  }

  .summary-item {
    min-width: 0;
    gap: 0.4rem;
  }

  .options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    font-size: 0.85rem;
  }

  .options>div {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 0;
  }

  .wrapper {
    padding: 0 0.75rem;
    gap: 1rem;
  }

  .mini-form-container {
    padding: 1rem;
    gap: 0.85rem;
  }

  .mini-form-container h5 {
    font-size: 1rem;
  }

  .busca-tipo-selector {
    gap: 1.25rem;
  }

  .search-box {
    flex-direction: column;
    gap: 0.65rem;
  }

  .input-search,
  .btn-buscar {
    width: 100%;
    min-height: 44px;
  }

  .participante-resultado-card {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
  }

  .participante-resultado-card .info {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .card-header-badge {
    flex-wrap: wrap;
  }

  .btn-adicionar-lista {
    width: 100%;
    min-height: 44px;
    white-space: normal;
  }

  .table-container {
    border-radius: 8px;
  }

  .attendance-table {
    min-width: 700px;
  }

  .attendance-table thead th {
    font-size: 0.78rem;
    padding: 11px 10px;
  }

  .attendance-table tbody td {
    font-size: 0.8rem;
    padding: 10px;
  }

  .custom-radio {
    width: 22px;
    height: 22px;
  }

  .table-container-empty {
    padding: 1.5rem 1rem;
  }

  .table-container-empty p {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .botoes-container {
    flex-direction: column-reverse;
    padding: 1.25rem 0.75rem;
    gap: 0.75rem;
  }

  .btn-salvar,
  .btn-voltar {
    width: 100%;
    padding: 12px 1rem;
  }

  .status-message {
    width: 100%;
    font-size: 0.85rem;
  }
}

@media (max-width: 360px) {
  .summary {
    grid-template-columns: 1fr;
  }

  .options {
    grid-template-columns: 1fr;
  }

  .infos-encontro p {
    font-size: 0.8rem;
  }
}
</style>
